import styled from "styled-components";

export const ContentHeaderControls = styled.div`
  margin-left: -15px;
  margin-right: -15px;
  text-align: right;

  .btn,
  .btn:focus,
  .btn:active,
  .btn:hover {
    background-color: #ff6400;
    border-color: #ff6400;
    border-radius: 0;
    color: white;
  }

  .btn .fas {
    display: inline-block;
  }
`;

/**
 * @deprecated
 */
export default ContentHeaderControls;
